import { useQuery } from '@tanstack/react-query'

import { GetSimulacoesRelacionadas } from '@/features/simulador/shared/http/get-simulacoes-relacionadas.service'
import { simulacaoKeys } from '@/utils/simulador-queries'

export const useSimulacoesRelacionadas = (idSimulacaoPrincipal: string) => {
  return useQuery({
    queryKey: simulacaoKeys.listaSimulacoesRelacionadas(idSimulacaoPrincipal),
    queryFn: async () => new GetSimulacoesRelacionadas().execute(idSimulacaoPrincipal).then((res) => res.data),
    gcTime: 0,
    enabled: false,
  })
}
